import React from "react";
import { Link } from "gatsby";
import "./tagsList.css";
import formatUrl from "../../utils/formatUrl";

export const TagsList = ({ tagsList }) => {
  const newTagsList = tagsList.slice(0, 6);
  return (
    <>
      <ul className="coop-c-list-tags">
        {newTagsList.map((tags, index) => (
          <li className="coop-c-tag" key={index}>
            <Link to={formatUrl(tags.slug, "tag")} className="coop-c-tag__link">
              {tags.name}
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
};
